import React from "react"
import { Card, CardBody, Row, Col, Button, Badge } from "reactstrap"
import { Link } from "react-router-dom"

const AdminActionCenter = () => {
  // Dummy data for admin actions - replace with real API data
  const actionData = {
    urgentActions: [
      {
        id: 1,
        title: "Review KYC Documents",
        count: 23,
        priority: "high",
        link: "/kyc",
        icon: "mdi-file-document-check",
        description: "Business verification pending"
      },
      {
        id: 2,
        title: "Process Claim Requests",
        count: 8,
        priority: "medium",
        link: "/Claim-requests",
        icon: "mdi-domain",
        description: "Business ownership claims"
      },
      {
        id: 3,
        title: "Resolve Payment Issues",
        count: 5,
        priority: "high",
        link: "/transactions",
        icon: "mdi-credit-card-alert",
        description: "Transaction disputes"
      }
    ],
    quickActions: [
      {
        title: "Add Portal User",
        link: "/PortalUsers",
        icon: "mdi-account-plus",
        color: "primary",
        description: "Create new admin user"
      },
      {
        title: "Manage Categories",
        link: "/categoryList",
        icon: "mdi-tag-multiple",
        color: "success",
        description: "Add or edit categories"
      },
      {
        title: "Institution Setup",
        link: "/institutions",
        icon: "mdi-school",
        color: "info",
        description: "Configure institutions"
      },
      {
        title: "Email Templates",
        link: "/EmailTemplateTable",
        icon: "mdi-email-edit",
        color: "warning",
        description: "Update email templates"
      },
      {
        title: "Site Settings",
        link: "/site-settings",
        icon: "mdi-cog",
        color: "secondary",
        description: "System configuration"
      },
      {
        title: "Newsletter",
        link: "/emailSubscriptions",
        icon: "mdi-newspaper",
        color: "dark",
        description: "Manage subscriptions"
      }
    ],
    recentActions: [
      { action: "User account suspended", admin: "Admin", time: "5 mins ago" },
      { action: "KYC document approved", admin: "Admin", time: "12 mins ago" },
      { action: "Category created", admin: "Admin", time: "25 mins ago" },
      { action: "Payment dispute resolved", admin: "Admin", time: "1 hour ago" }
    ]
  }

  const getPriorityColor = (priority) => {
    return priority === 'high' ? 'danger' : priority === 'medium' ? 'warning' : 'info'
  }

  return (
    <Card className="border-0 shadow-sm">
      <CardBody>
        <h4 className="card-title mb-4">Admin Action Center</h4>

        {/* Urgent Actions */}
        <div className="mb-3">
          <h6 className="mb-3 d-flex align-items-center">
            <i className="mdi mdi-alert-circle text-danger me-2"></i>
            Urgent Actions Required
          </h6>
          {actionData.urgentActions.map((action) => (
            <div key={action.id} className="d-flex align-items-center justify-content-between p-2 border rounded mb-2">
              <div className="d-flex align-items-center">
                <div className={`avatar-sm rounded-circle bg-${getPriorityColor(action.priority)} d-flex align-items-center justify-content-center me-2`}>
                  <i className={`mdi ${action.icon} text-white`}></i>
                </div>
                <div>
                  <h6 className="mb-0 font-size-14">{action.title}</h6>
                  <p className="text-muted mb-0 font-size-12">{action.description}</p>
                </div>
              </div>
              <div className="d-flex align-items-center gap-1">
                <Badge color={getPriorityColor(action.priority)} className="rounded-pill font-size-11">
                  {action.count}
                </Badge>
                <Link to={action.link} className={`btn btn-${getPriorityColor(action.priority)} btn-sm font-size-11`}>
                  Action
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Actions Grid - Simplified */}
        <div className="mb-3">
          <h6 className="mb-3">Quick Actions</h6>
          <Row>
            {actionData.quickActions.slice(0, 4).map((action, index) => (
              <Col md={6} sm={6} key={index} className="mb-2">
                <Link to={action.link} className="text-decoration-none">
                  <div className="p-2 border rounded text-center quick-action-card">
                    <div className={`avatar-sm rounded-circle bg-${action.color} d-flex align-items-center justify-content-center mx-auto mb-2`}>
                      <i className={`mdi ${action.icon} text-white font-size-16`}></i>
                    </div>
                    <h6 className="mb-0 font-size-13">{action.title}</h6>
                    <p className="text-muted mb-0 font-size-11">{action.description}</p>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </div>

        {/* Recent Admin Actions */}
        <div>
          <h6 className="mb-3">Recent Admin Actions</h6>
          {actionData.recentActions.map((item, index) => (
            <div key={index} className="d-flex align-items-center justify-content-between mb-2 p-2 bg-light rounded">
              <div className="d-flex align-items-center">
                <div className="avatar-xs rounded-circle bg-success d-flex align-items-center justify-content-center me-2">
                  <i className="mdi mdi-check text-white font-size-10"></i>
                </div>
                <span className="font-size-13">{item.action}</span>
              </div>
              <small className="text-muted font-size-11">{item.time}</small>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  )
}

export default AdminActionCenter